import React, { useEffect, useMemo, useState } from 'react';
import { Checkbox, Flex, Input, Modal, Space } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getArtworkCampusRejectItems } from '@/api/artworkVerify';

interface RejectDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (selectedKeys: number[], remark: string) => void;
}

const RejectDialog: React.FC<RejectDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [remarkChecked, setRemarkChecked] = useState<boolean>(false);
  const [textValue, setTextValue] = useState<string>('');
  const [selectKeys, setSelectedKeys] = useState<number[]>([]);

  const { data: rejectReason } = useQuery({
    queryKey: ['artworkCampusRejectReason'],
    queryFn: async () => {
      const resp = await getArtworkCampusRejectItems();
      if (resp.status !== 200) {
        return [];
      }
      const data = resp.data.map((item) => ({
        label: item.dictDesc,
        value: item.dictKey,
      }));
      return data;
    },
  });

  const handleOk = () => {
    const selectedKeys = selectKeys.filter((item) => item);
    onConfirm(selectedKeys, textValue);
  };

  useEffect(() => {
    setSelectedKeys([]);
    setRemarkChecked(false);
    setTextValue('');
  }, [isOpen]);

  const handleOkDisabled = useMemo(() => {
    if (remarkChecked && textValue.length === 0) {
      return true;
    }
    return selectKeys.length === 0;
  }, [selectKeys, remarkChecked, textValue]);

  return (
    <Modal
      open={isOpen}
      title="请选择驳回原因"
      width={500}
      onCancel={onClose}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
      okButtonProps={{
        danger: true,
        disabled: handleOkDisabled,
      }}
      destroyOnClose
    >
      <Flex style={{ width: '100%', flexWrap: 'nowrap', columnGap: 0 }}>
        <Checkbox.Group onChange={(values) => setSelectedKeys(values)}>
          <Space direction="vertical">
            {rejectReason?.map((item, index) => (
              <Checkbox key={index} value={item.value}>
                {item.label}
              </Checkbox>
            ))}
            <Checkbox onChange={(e) => setRemarkChecked(e.target.checked)}>
              其它（备注）
            </Checkbox>
          </Space>
        </Checkbox.Group>
      </Flex>
      <Flex style={{ marginTop: 10, alignItems: 'flex-start' }}>
        <Input.TextArea
          rows={4}
          maxLength={6}
          disabled={!remarkChecked}
          value={textValue}
          allowClear
          onChange={(e) => setTextValue(e.target.value)}
        />
      </Flex>
    </Modal>
  );
};

export default RejectDialog;
